export function convertCentsToEuros(amountInCents: number): number {
    return amountInCents / 100;
}
